import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/siteData";

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto" className="py-20 md:py-32 bg-white border-y border-black/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400 mb-4">Why homeowners choose us</p>
            <h2 className="font-display font-extrabold tracking-tight leading-none text-4xl sm:text-5xl">
              The Aqua Control standard.
            </h2>
            <p className="mt-6 text-base md:text-lg text-neutral-600 max-w-sm">
              Three principles behind every job — no matter how big or how small.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 flex flex-col">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className={`grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 ${i !== 0 ? "border-t border-black/10" : ""}`}
            >
              <span className="font-display font-extrabold text-6xl md:text-8xl leading-none" style={{ color: ["#FFB300", "#007AFF", "#FF3B30"][i] }}>
                {m.no}
              </span>
              <div>
                <h3 className="text-2xl md:text-3xl font-display font-bold tracking-tight">{m.title}</h3>
                <p className="mt-3 text-base md:text-lg leading-relaxed text-neutral-600 max-w-xl">{m.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
